import React from "react";
import { Avatar, Icon } from "../ui";
import ChatIcon from "./ChatIcon";
import { TYPING_PHRASES, fillVars, renderContent, timeOf } from "./format";

export function TypingBubble({ char, label }) {
  const phrase = React.useMemo(() => label || TYPING_PHRASES[Math.floor(Math.random() * TYPING_PHRASES.length)], [label]);
  return (
    <div className="msg-row msg-row--char" role="status" aria-label="ตัวละครกำลังพิมพ์">
      <Avatar name={char.name} seed={char.seed} colors={char.colors} src={char.image} size={36} character />
      <div className="msg msg--char">
        <div className="msg__bubble typing-line"><span className="typing" aria-hidden="true"><i /><i /><i /></span><span className="muted">{phrase}</span></div>
      </div>
    </div>
  );
}

/** ข้อความหนึ่งรายการ — user ชิดขวา, ตัวละครมีอวาตาร์ + ป้าย + ปุ่ม (เจนใหม่เฉพาะข้อความล่าสุด) */
export default function MessageItem({ m, char, userName, personaName, canRegen, regenCost, onRegen, onLike, onCopy, busy, joy }) {
  if (m.type === "gift") {
    // บับเบิลของขวัญ: ไอคอน + ชื่อ + ราคา + ตัวนับคอมโบ (ข้อความเก่าที่ไม่มีฟิลด์เหล่านี้ใช้ข้อความเดิม)
    if (!m.giftName) return <div className="msg-gift msg-gift--plain" role="note"><Icon name="gift" size={15} />{String(m.content || "").replace(/\*/g, "")}</div>;
    const combo = Number(m.combo) || 1;
    return (
      <div className={`msg-gift msg-gift--${m.tier || "small"}`} role="note" data-testid="gift-bubble" aria-label={`${personaName || userName} ส่ง ${m.giftName}${combo > 1 ? ` x${combo}` : ""}`}>
        <span className="msg-gift__ico" aria-hidden="true">{m.giftIcon || "🎁"}</span>
        <span className="msg-gift__txt"><b className="clamp-1">{m.giftName}</b>{m.coinCost ? <small>{Number(m.coinCost).toLocaleString("th-TH")} คอยน์</small> : null}</span>
        {combo > 1 ? <span className="msg-gift__combo">x{combo}</span> : null}
      </div>
    );
  }
  const mine = m.sender === "user";
  const text = fillVars(m.content, userName, char.name);
  if (mine) {
    return (
      <div className={`msg-row msg-row--user${m.pending ? " is-pending" : ""}`}>
        <div className="msg msg--user">
          <div className="msg__who">{personaName || userName}</div>
          <div className="msg__bubble">{renderContent(text)}</div>
          <div className="msg__meta">{m.pending ? <span>กำลังส่ง...</span> : <span>{timeOf(m.createdAt)}</span>}</div>
        </div>
      </div>
    );
  }
  return (
    <div className={`msg-row msg-row--char${joy ? " msg-row--joy" : ""}`}>
      <Avatar name={char.name} seed={char.seed} colors={char.colors} src={char.image} size={36} character />
      <div className="msg msg--char">
        <div className="msg__who">{char.name} <span className="chip chip--sm">ตัวละคร</span></div>
        <div className="msg__bubble">{renderContent(text)}</div>
        {m.streaming ? null : <><div className="msg__meta">
          {m.romanticDelta ? <span className="delta delta--love"><Icon name="heart" size={12} filled /> {m.romanticDelta > 0 ? "+" : ""}{m.romanticDelta}</span> : null}
          {m.intimacyDelta ? <span className="delta delta--friend"><Icon name="users" size={12} /> {m.intimacyDelta > 0 ? "+" : ""}{m.intimacyDelta}</span> : null}
          <span>{timeOf(m.createdAt)}</span>
        </div>
        <div className="msg__actions">
          {canRegen ? (
            <button className="msg-act msg-act--wide" onClick={onRegen} disabled={busy} aria-label={`เจนข้อความใหม่ ใช้ ${regenCost} คอยน์`} title={`เจนข้อความใหม่ (${regenCost} คอยน์)`}>
              <ChatIcon name="refresh" size={15} />เจนใหม่ · {regenCost}
            </button>
          ) : null}
          <button className={`msg-act${m.reaction === "like" ? " is-on" : ""}`} onClick={onLike} aria-pressed={m.reaction === "like"} aria-label="ถูกใจข้อความนี้"><ChatIcon name="thumb" size={15} filled={m.reaction === "like"} /></button>
          <button className="msg-act" onClick={onCopy} aria-label="คัดลอกข้อความ"><ChatIcon name="copy" size={15} /></button>
        </div></>}
      </div>
    </div>
  );
}
